import React, { useState } from 'react';
import { AuthLayout, Button, TextField } from '@talbenmoshe/trip-os-design-system';
import { SignInActivity, SignInFailure, useSignIn, useSignInFacade } from '@talbenmoshe/trip-os-react-model';
import { useMessages } from '../i18n/messagesContext.js';
import { SignInNoticeBanner } from './SignInNoticeBanner.js';

/** Step 1 of sign-in (frames C1–C3): the email address and "Send me a code". */
export function EmailStep() {
  const messages = useMessages();
  const signIn = useSignIn();
  const facade = useSignInFacade();
  const [emailDraft, setEmailDraft] = useState(signIn.email);
  const isSending = signIn.activity === SignInActivity.SENDING_CODE;
  const emailError = signIn.failure === SignInFailure.INVALID_EMAIL ? messages.SIGN_IN_INVALID_EMAIL() : undefined;

  function handleSubmit(): void {
    void facade.requestSignInCode(emailDraft);
  }

  return (
    <AuthLayout
      wordmarkLabel={messages.SIGN_IN_WORDMARK_LABEL()}
      title={messages.SIGN_IN_EMAIL_TITLE()}
      description={messages.SIGN_IN_EMAIL_DESCRIPTION()}
      notice={<SignInNoticeBanner failure={signIn.failure} notice={signIn.notice} />}
      footnote={messages.SIGN_IN_NEW_ACCOUNT_NOTE()}
      onSubmit={handleSubmit}
    >
      <TextField
        label={messages.SIGN_IN_EMAIL_LABEL()}
        value={emailDraft}
        onChange={setEmailDraft}
        placeholder={messages.SIGN_IN_EMAIL_PLACEHOLDER()}
        error={emailError}
        errorRevision={signIn.failureRevision}
        type="email"
        autoComplete="email"
        required
        disabled={isSending}
        autoFocus
      />
      <Button
        label={messages.SIGN_IN_SEND_CODE()}
        type="submit"
        fullWidth
        loading={isSending}
        loadingLabel={messages.SIGN_IN_SENDING_CODE()}
      />
    </AuthLayout>
  );
}
